import type { PaginationClass } from '@/shared'
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationNext,
  PaginationPrevious,
} from '@/components/ui/pagination'
import { generatePaginationLinks } from './generate-pages'

export const PaginationView = ({
  pagination,
  onPageChange,
  showPreviousNext = true,
  className,
}: {
  pagination: PaginationClass
  onPageChange: any
  showPreviousNext?: boolean
  className?: string
}) => {
  return (
    <Pagination className={className}>
      <PaginationContent>
        {showPreviousNext && pagination.totalPages ? (
          <PaginationItem>
            <PaginationPrevious
              onClick={() => onPageChange(pagination.page - 1)}
              disabled={pagination.page - 1 < 1}
            />
          </PaginationItem>
        ) : null}
        {generatePaginationLinks(
          pagination.page,
          pagination.totalPages,
          onPageChange,
        )}
        {showPreviousNext && pagination.totalPages ? (
          <PaginationItem>
            <PaginationNext
              onClick={() => onPageChange(pagination.page + 1)}
              disabled={pagination.page > pagination.totalPages - 1}
            />
          </PaginationItem>
        ) : null}
      </PaginationContent>
    </Pagination>
  )
}
